import { useHead } from '@vueuse/head'

export function usePageMeta({ title, description, image }) {
  useHead(() => ({
    title: title?.value || title || 'Sehrish Mart',
    meta: [
      {
        name: 'description',
        content: description?.value || description || ''
      },
      {
        property: 'og:title',
        content: title?.value || title || ''
      },
      {
        property: 'og:description',
        content: description?.value || description || ''
      },
      ...(image?.value || image
        ? [
            {
              property: 'og:image',
              content: image?.value || image
            }
          ]
        : [])
    ]
  }))
}